import { Record } from "immutable";
import type GroupWithExpiration from "models/interfaces/group-with-expiration";
import { RecordUtils } from "@rsm-hcd/javascript-core";

const defaultValues: GroupWithExpiration =
    RecordUtils.auditableDefaultValuesFactory<GroupWithExpiration>({
        externalIdentifier: undefined,
        name: "",
        totalLicenses: 0,
        subscriptionExpiresOn: undefined,
    });

export default class GroupWithExpirationRecord
    extends Record(defaultValues)
    implements GroupWithExpiration
{
    // Do NOT set properties on immutable records due to babel and typescript transpilation issue
    // See https://github.com/facebook/create-react-app/issues/6506

    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: GroupWithExpiration) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<GroupWithExpiration>} values
     */
    public with(
        values: Partial<GroupWithExpiration>
    ): GroupWithExpirationRecord {
        return new GroupWithExpirationRecord(
            Object.assign(this.toJS(), values)
        );
    }

    // #endregion Public Methods
}
